import { previousMonday, nextMonday, startOfDay, isYesterday } from 'date-fns';

export const dateHelper = {
  isInDateRange: (dateTs, range, dates) => {
    const date = new Date(dateTs * 1000);
    const now = new Date();
    // Multiple ways to do these...
    const startOfWeek = startOfDay(previousMonday(now));
    const endOfWeek = startOfDay(nextMonday(now));
    const startOfPreviousWeek = startOfDay(previousMonday(startOfWeek));
    const endOfPreviousWeek = startOfDay(previousMonday(now));

    switch (range) {
      case "all":
        return true;
      case "today": 
        return date.getDate() === now.getDate();
      case "yesterday":
        return isYesterday(date);
      case "thisWeek":
        return date > startOfWeek && date < endOfWeek;
      case "lastWeek":
        return date > startOfPreviousWeek && date < endOfPreviousWeek;
      case "thisMonth":
        return date.getMonth() === now.getMonth();
      case "lastMonth": {
        let prev = now.getMonth()-1;
        if (prev < 0) {
          prev = 11;
        }
        return date.getMonth() === prev;
      }
      case "custom":
        return date >= new Date(dates.start) && date <= new Date(dates.end);
      default:
        return false;
    }
  }
};
